import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    error: '',
};
const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        showError: (state, action) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = '';
        },
    },
});
export const { showError, clearError } = errorSlice.actions;
export default errorSlice.reducer;
